const CHECKBOX_TRUE_VALUE = "1";

export default CHECKBOX_TRUE_VALUE;
